import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import hero_1 from '../../images/AE-Hero.svg';
import hero_2 from '../../images/AE-Hero-6.jpg';
import hero_3 from '../../images/AE-img-4.jpeg';
import hero_4 from '../../images/AE-img-2.jpeg';
import hero_5 from '../../images/AE-img-6.jpeg';

const Hero = () => {
    const slides = [
        // --- Solar Services ---
        {
            image: hero_1,
            title: "Powering Businesses with Sustainable Energy",
            description: "Professional solar panel installation for residential and commercial properties — from roof assessment to final connection, using high-efficiency panels and inverters to maximise your savings."
        },
        {
            image: hero_2,
            title: "Custom Solar Design & Consultation",
            description: "We analyse your energy consumption, roof orientation, and local climate to design a tailored solar array that delivers maximum return on investment for your home or business."
        },
        {
            image: hero_3,
            title: "Harvest the Sun, Store the Power",
            description: "Every panel we install is the start of something bigger — a system that captures clean energy all day and stores it for when you need it most. From rooftop to battery, we build solar solutions that work around the clock."
        },
        // --- Electrical Services ---
        {
            image: hero_4,
            title: "Professional Electrical Installation & Wiring",
            description: "Certified electricians handling all wiring, outlets, switches, and lighting installations for new builds, renovations, and upgrades — with strict adherence to safety codes."
        },
        {
            image: hero_5,
            title: "Powering Spaces, Big & Small",
            description: "Whether it's a packed stadium or a single home, our electrical expertise ensures every space gets the reliable, safe power it deserves — installed and inspected to the highest standards."
        },
    ];

    return (
        <>
            <section id="hero" className="hero section dark-background">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay, EffectFade]}
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    pagination={{
                        clickable: true,
                        el: '.swiper-pagination'
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    effect="fade"
                    fadeEffect={{ crossFade: true }}
                    loop={true}
                    className="w-full h-screen"
                    style={{ width: '100%', height: '100vh' }}
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index} className="relative w-full h-full">
                            {/* This div simulates the .carousel-item from the original CSS */}
                            <div className="carousel-item w-full h-full">
                                <img
                                    src={slide.image}
                                    alt={`hero_${index + 1}`}
                                    className="absolute inset-0 w-full h-full object-cover"
                                    style={{
                                        objectFit: index === 0 ? 'contain' : 'cover',
                                        objectPosition: 'center center',
                                        width: '100%',
                                        height: '100%',
                                        top: index === 0 ? '60px' : '0',
                                        backgroundColor: index === 0 ? '#fff' : 'transparent',
                                    }}
                                />
                                {/* Dark overlay for better text readability */}
                                <div className="absolute inset-0 bg-black bg-opacity-40 z-5"></div>

                                {/* Text content - this will use the CSS from index.css */}
                                <div className="carousel-container absolute inset-0 flex flex-col items-center justify-center text-center text-white z-10 px-4 md:px-8 lg:px-16">
                                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 max-w-4xl">{slide.title}</h2>
                                    <p className="text-lg md:text-xl max-w-3xl mb-8">{slide.description}</p>
                                    {/* Optional: Add a button if needed */}
                                    {/* <button className="btn-get-started bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-full transition duration-300">
                                        Get Started
                                    </button> */}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

                    {/* Navigation Buttons */}
                    <div className="swiper-button-prev carousel-control-prev absolute left-4 top-1/2 -translate-y-1/2 z-20 cursor-pointer opacity-70 hover:opacity-100 transition-opacity">
                        <span className="carousel-control-prev-icon bi bi-chevron-left text-white text-4xl" aria-hidden="true"></span>
                    </div>
                    <div className="swiper-button-next carousel-control-next absolute right-4 top-1/2 -translate-y-1/2 z-20 cursor-pointer opacity-70 hover:opacity-100 transition-opacity">
                        <span className="carousel-control-next-icon bi bi-chevron-right text-white text-4xl" aria-hidden="true"></span>
                    </div>

                    {/* Pagination */}
                    <div className="swiper-pagination carousel-indicators absolute bottom-4 left-0 right-0 z-20"></div>
                </Swiper>
            </section>
        </>
    );
};

export default Hero;